module.exports = __webpack_public_path__ + "img/sort.585ab1fb.svg";